import { formatPrice, genGetLabel, genHtmlOptions, genMenuItems, genOptions } from '../utils';
import PlaceWrapper from './PlaceWrapper';

// import sharedContext from '../sharedContext';

export const ACTIVITY_TYPES = {};
export const ACTIVITY_TYPE_THINGS_TO_DO = 1;
export const ACTIVITY_TYPE_FOOD_AND_DRINK = 2;
export const ACTIVITY_TYPE_LODGING = 3;
export const ACTIVITY_TYPE_TRANSPORTATION = 4;
export const ACTIVITY_TYPE_ATTRACTION = 5;
ACTIVITY_TYPES[ACTIVITY_TYPE_THINGS_TO_DO] = "Things To Do";
ACTIVITY_TYPES[ACTIVITY_TYPE_FOOD_AND_DRINK] = "Food & Drink";
ACTIVITY_TYPES[ACTIVITY_TYPE_LODGING] = "Lodging";
ACTIVITY_TYPES[ACTIVITY_TYPE_TRANSPORTATION] = "Transportation";
ACTIVITY_TYPES[ACTIVITY_TYPE_ATTRACTION] = "Attraction";

export const PAYMENT_TYPES = {};
export const PAYMENT_TYPE_INCLUDED = 0;
export const PAYMENT_TYPE_PAY_AT_LOCATION = 1;
export const PAYMENT_TYPE_PREPAID_ADDON = 2;
PAYMENT_TYPES[PAYMENT_TYPE_INCLUDED] = "Included";
PAYMENT_TYPES[PAYMENT_TYPE_PAY_AT_LOCATION] = "Pay At Location";
PAYMENT_TYPES[PAYMENT_TYPE_PREPAID_ADDON] = "Prepaid Add-On";


export const PRICE_TYPES = {}
export const PRICE_TYPE_DONT_DISPLAY = 0;
export const PRICE_TYPE_PRICE_LEVEL = 1;
export const PRICE_TYPE_EXACT_PRICE = 2;
export const PRICE_TYPE_PRICE_RANGE = 3;
PRICE_TYPES[PRICE_TYPE_DONT_DISPLAY] = "Don't Display";
PRICE_TYPES[PRICE_TYPE_PRICE_LEVEL] = "Price Level";
PRICE_TYPES[PRICE_TYPE_EXACT_PRICE] = "Exact Price";
PRICE_TYPES[PRICE_TYPE_PRICE_RANGE] = "Price Range";


export const CURRENCY_DISPLAY_TYPES = {};
export const CURRENCY_DISPLAY_TYPE_DEFAULT = 1;
export const CURRENCY_DISPLAY_TYPE_USD = 2;
export const CURRENCY_DISPLAY_TYPE_LOCAL = 3;
export const CURRENCY_DISPLAY_TYPE_DEVICE = 4;
CURRENCY_DISPLAY_TYPES[CURRENCY_DISPLAY_TYPE_DEFAULT] = "Default";
CURRENCY_DISPLAY_TYPES[CURRENCY_DISPLAY_TYPE_USD] = "USD";
CURRENCY_DISPLAY_TYPES[CURRENCY_DISPLAY_TYPE_LOCAL] = "Country local currency";
CURRENCY_DISPLAY_TYPES[CURRENCY_DISPLAY_TYPE_DEVICE] = "User device's currency";

export const REVIEW_SOURCES = {};
export const REVIEW_SOURCE_OVERALL = "Overall";
export const REVIEW_SOURCE_TRIPADVISOR = "TripAdvisor";
export const REVIEW_SOURCE_GOOGLE = "Google";
export const REVIEW_SOURCE_YELP = "Yelp";
REVIEW_SOURCES[REVIEW_SOURCE_OVERALL] = "Overall";
REVIEW_SOURCES[REVIEW_SOURCE_TRIPADVISOR] = "TripAdvisor";
REVIEW_SOURCES[REVIEW_SOURCE_GOOGLE] = "Google";
REVIEW_SOURCES[REVIEW_SOURCE_YELP] = "Yelp";

export const REVIEW_ENTRY_TYPES = {};
export const REVIEW_ENTRY_TYPE_COUNTS = "Counts";
export const REVIEW_ENTRY_TYPE_PCTS = "Pcts";
export const REVIEW_ENTRY_TYPE_TOTALS = "Totals";
REVIEW_ENTRY_TYPES[REVIEW_ENTRY_TYPE_COUNTS] = "Counts";
REVIEW_ENTRY_TYPES[REVIEW_ENTRY_TYPE_PCTS] = "Pcts";
REVIEW_ENTRY_TYPES[REVIEW_ENTRY_TYPE_TOTALS] = "Totals";

export const PRICE_LEVELS = {};
export const PRICE_LEVEL_1 = 1;
export const PRICE_LEVEL_2 = 2;
export const PRICE_LEVEL_3 = 3;
export const PRICE_LEVEL_4 = 4;
PRICE_LEVELS[PRICE_LEVEL_1] = '$';
PRICE_LEVELS[PRICE_LEVEL_2] = '$$';
PRICE_LEVELS[PRICE_LEVEL_3] = '$$$';
PRICE_LEVELS[PRICE_LEVEL_4] = '$$$$';

export const PRICE_DISPLAY = {};
export const PRICE_DISPLAY_NO_PRICE = PRICE_TYPE_DONT_DISPLAY;
export const PRICE_DISPLAY_PRICE_LEVEL = PRICE_TYPE_PRICE_LEVEL;
export const PRICE_DISPLAY_EXACT_PRICE = PRICE_TYPE_EXACT_PRICE;
export const PRICE_DISPLAY_PRICE_RANGE = PRICE_TYPE_PRICE_RANGE;
export const PRICE_DISPLAY_INCLUDED = PRICE_DISPLAY_PRICE_RANGE + 1;
export const PRICE_DISPLAY_FREE = PRICE_DISPLAY_PRICE_RANGE + 2;
PRICE_DISPLAY[PRICE_DISPLAY_NO_PRICE] = "Don't Display Price";
PRICE_DISPLAY[PRICE_DISPLAY_INCLUDED] = "Included";
PRICE_DISPLAY[PRICE_DISPLAY_FREE] = "Free";
PRICE_DISPLAY[PRICE_DISPLAY_PRICE_LEVEL] = "Price Level";
PRICE_DISPLAY[PRICE_DISPLAY_EXACT_PRICE] = "Exact Price";
PRICE_DISPLAY[PRICE_DISPLAY_PRICE_RANGE] = "Price Range";


export const guessPriceDisplay = (act) => {
    if (!act) {
        return PRICE_DISPLAY_NO_PRICE;
    } else if (act.price_display !== void (0)) {
        return act.price_display;
    }
    if (act.payment_type === PAYMENT_TYPE_INCLUDED) {
        return PRICE_DISPLAY_INCLUDED;
    } else { // if (act.payment_type === PAYMENT_TYPE_PAY_AT_LOCATION || act.payment_type === PAYMENT_TYPE_PREPAID_ADDON) {
        if ((act.price_type === PRICE_TYPE_EXACT_PRICE) && (+act.cost_min === 0)) {
            return PRICE_DISPLAY_FREE;
        } else {
            return act.price_type; // coincides with first 4 price display values
        }
    }
}

export const parsePriceDisplay = (pd) => {
    if (pd === PRICE_DISPLAY_INCLUDED) {
        return { payment_type: PAYMENT_TYPE_INCLUDED, price_type: PRICE_TYPE_DONT_DISPLAY }
    } else if (pd === PRICE_DISPLAY_FREE) {
        return { payment_type: PAYMENT_TYPE_PAY_AT_LOCATION, price_type: PRICE_TYPE_EXACT_PRICE, cost_min: 0 }
    } else {
        return { payment_type: PAYMENT_TYPE_PAY_AT_LOCATION, price_type: pd }
    }
}


export const activityTypeLabel = genGetLabel(ACTIVITY_TYPES, 1);
export const paymentTypeLabel = genGetLabel(PAYMENT_TYPES, 0);
export const priceTypeLabel = genGetLabel(PRICE_TYPES, 0);

export const activityTypeOptions = genOptions(ACTIVITY_TYPES);
export const paymentTypeOptions = genOptions(PAYMENT_TYPES);
export const priceTypeOptions = genOptions(PRICE_TYPES);
export const currencyDisplayOptions = genOptions(CURRENCY_DISPLAY_TYPES);
export const priceLevelOptions = genOptions(PRICE_LEVELS);
export const reviewEntryTypesOptions = genOptions(REVIEW_ENTRY_TYPES);
export const reviewSourcesOptions = genOptions(REVIEW_SOURCES);
export const priceDisplayOptions = genOptions(PRICE_DISPLAY);

export const activityTypeHtmlOptions = genHtmlOptions(ACTIVITY_TYPES);
export const paymentTypeHtmlOptions = genHtmlOptions(PAYMENT_TYPES);
export const priceTypeHtmlOptions = genHtmlOptions(PRICE_TYPES);
export const currencyDisplayHtmlOptions = genHtmlOptions(CURRENCY_DISPLAY_TYPES);
export const priceLevelHtmlOptions = genHtmlOptions(PRICE_LEVELS);
export const reviewEntryTypesHtmlOptions = genHtmlOptions(REVIEW_ENTRY_TYPES);
export const reviewSourcesHtmlOptions = genHtmlOptions(REVIEW_SOURCES);
export const priceDisplayHtmlOptions = genHtmlOptions(PRICE_DISPLAY);

export const activityTypeMenuItems = genMenuItems(ACTIVITY_TYPES);
export const paymentTypeMenuItems = genMenuItems(PAYMENT_TYPES);
export const priceTypeMenuItems = genMenuItems(PRICE_TYPES);
export const currencyDisplayMenuItems = genMenuItems(CURRENCY_DISPLAY_TYPES);
export const priceLevelMenuItems = genMenuItems(PRICE_LEVELS);
export const reviewEntryTypesMenuItems = genMenuItems(REVIEW_ENTRY_TYPES);
export const reviewSourcesMenuItems = genMenuItems(REVIEW_SOURCES);
export const priceDisplayMenuItems = genMenuItems(PRICE_DISPLAY);


// export const getCountriesMenuItems = () => ( objectListToMenuItems(sharedContext.get('countries', [])) );
// export const getCurrenciesMenuItems = (empty, nameFn) => (
//     objectListToMenuItems(
//         sharedContext.get('currencies', []),
//         {
//             empty: empty,
//             name: (nameFn || 'iso')
//         }
//     )
// );

const typeMap = {
    'accounting': ACTIVITY_TYPE_THINGS_TO_DO,
    'airport': ACTIVITY_TYPE_THINGS_TO_DO,
    'amusement_park': ACTIVITY_TYPE_THINGS_TO_DO,
    'aquarium': ACTIVITY_TYPE_THINGS_TO_DO,
    'art_gallery': ACTIVITY_TYPE_THINGS_TO_DO,
    'atm': ACTIVITY_TYPE_THINGS_TO_DO,
    'bakery': ACTIVITY_TYPE_FOOD_AND_DRINK,
    'bank': ACTIVITY_TYPE_THINGS_TO_DO,
    'bar': ACTIVITY_TYPE_FOOD_AND_DRINK,
    'beauty_salon': ACTIVITY_TYPE_THINGS_TO_DO,
    'bicycle_store': ACTIVITY_TYPE_THINGS_TO_DO,
    'book_store': ACTIVITY_TYPE_THINGS_TO_DO,
    'bowling_alley': ACTIVITY_TYPE_THINGS_TO_DO,
    'bus_station': ACTIVITY_TYPE_THINGS_TO_DO,
    'cafe': ACTIVITY_TYPE_FOOD_AND_DRINK,
    'campground': ACTIVITY_TYPE_LODGING,
    'car_dealer': ACTIVITY_TYPE_THINGS_TO_DO,
    'car_rental': ACTIVITY_TYPE_THINGS_TO_DO,
    'car_repair': ACTIVITY_TYPE_THINGS_TO_DO,
    'car_wash': ACTIVITY_TYPE_THINGS_TO_DO,
    'casino': ACTIVITY_TYPE_THINGS_TO_DO,
    'cemetery': ACTIVITY_TYPE_THINGS_TO_DO,
    'church': ACTIVITY_TYPE_THINGS_TO_DO,
    'city_hall': ACTIVITY_TYPE_THINGS_TO_DO,
    'clothing_store': ACTIVITY_TYPE_THINGS_TO_DO,
    'convenience_store': ACTIVITY_TYPE_THINGS_TO_DO,
    'courthouse': ACTIVITY_TYPE_THINGS_TO_DO,
    'dentist': ACTIVITY_TYPE_THINGS_TO_DO,
    'department_store': ACTIVITY_TYPE_THINGS_TO_DO,
    'doctor': ACTIVITY_TYPE_THINGS_TO_DO,
    'drugstore': ACTIVITY_TYPE_THINGS_TO_DO,
    'electrician': ACTIVITY_TYPE_THINGS_TO_DO,
    'electronics_store': ACTIVITY_TYPE_THINGS_TO_DO,
    'embassy': ACTIVITY_TYPE_THINGS_TO_DO,
    'fire_station': ACTIVITY_TYPE_THINGS_TO_DO,
    'florist': ACTIVITY_TYPE_THINGS_TO_DO,
    'funeral_home': ACTIVITY_TYPE_THINGS_TO_DO,
    'furniture_store': ACTIVITY_TYPE_THINGS_TO_DO,
    'gas_station': ACTIVITY_TYPE_THINGS_TO_DO,
    'grocery_or_supermarket': ACTIVITY_TYPE_THINGS_TO_DO,
    'gym': ACTIVITY_TYPE_THINGS_TO_DO,
    'hair_care': ACTIVITY_TYPE_THINGS_TO_DO,
    'hardware_store': ACTIVITY_TYPE_THINGS_TO_DO,
    'hindu_temple': ACTIVITY_TYPE_THINGS_TO_DO,
    'home_goods_store': ACTIVITY_TYPE_THINGS_TO_DO,
    'hospital': ACTIVITY_TYPE_THINGS_TO_DO,
    'insurance_agency': ACTIVITY_TYPE_THINGS_TO_DO,
    'jewelry_store': ACTIVITY_TYPE_THINGS_TO_DO,
    'laundry': ACTIVITY_TYPE_THINGS_TO_DO,
    'lawyer': ACTIVITY_TYPE_THINGS_TO_DO,
    'library': ACTIVITY_TYPE_THINGS_TO_DO,
    'light_rail_station': ACTIVITY_TYPE_THINGS_TO_DO,
    'liquor_store': ACTIVITY_TYPE_THINGS_TO_DO,
    'local_government_office': ACTIVITY_TYPE_THINGS_TO_DO,
    'locksmith': ACTIVITY_TYPE_THINGS_TO_DO,
    'lodging': ACTIVITY_TYPE_LODGING,
    'meal_delivery': ACTIVITY_TYPE_FOOD_AND_DRINK,
    'meal_takeaway': ACTIVITY_TYPE_FOOD_AND_DRINK,
    'mosque': ACTIVITY_TYPE_THINGS_TO_DO,
    'movie_rental': ACTIVITY_TYPE_THINGS_TO_DO,
    'movie_theater': ACTIVITY_TYPE_THINGS_TO_DO,
    'moving_company': ACTIVITY_TYPE_THINGS_TO_DO,
    'museum': ACTIVITY_TYPE_THINGS_TO_DO,
    'night_club': ACTIVITY_TYPE_THINGS_TO_DO,
    'painter': ACTIVITY_TYPE_THINGS_TO_DO,
    'park': ACTIVITY_TYPE_THINGS_TO_DO,
    'parking': ACTIVITY_TYPE_THINGS_TO_DO,
    'pet_store': ACTIVITY_TYPE_THINGS_TO_DO,
    'pharmacy': ACTIVITY_TYPE_THINGS_TO_DO,
    'physiotherapist': ACTIVITY_TYPE_THINGS_TO_DO,
    'plumber': ACTIVITY_TYPE_THINGS_TO_DO,
    'police': ACTIVITY_TYPE_THINGS_TO_DO,
    'post_office': ACTIVITY_TYPE_THINGS_TO_DO,
    'primary_school': ACTIVITY_TYPE_THINGS_TO_DO,
    'real_estate_agency': ACTIVITY_TYPE_THINGS_TO_DO,
    'restaurant': ACTIVITY_TYPE_FOOD_AND_DRINK,
    'roofing_contractor': ACTIVITY_TYPE_THINGS_TO_DO,
    'rv_park': ACTIVITY_TYPE_THINGS_TO_DO,
    'school': ACTIVITY_TYPE_THINGS_TO_DO,
    'secondary_school': ACTIVITY_TYPE_THINGS_TO_DO,
    'shoe_store': ACTIVITY_TYPE_THINGS_TO_DO,
    'shopping_mall': ACTIVITY_TYPE_THINGS_TO_DO,
    'spa': ACTIVITY_TYPE_THINGS_TO_DO,
    'stadium': ACTIVITY_TYPE_THINGS_TO_DO,
    'storage': ACTIVITY_TYPE_THINGS_TO_DO,
    'store': ACTIVITY_TYPE_THINGS_TO_DO,
    'subway_station': ACTIVITY_TYPE_THINGS_TO_DO,
    'supermarket': ACTIVITY_TYPE_THINGS_TO_DO,
    'synagogue': ACTIVITY_TYPE_THINGS_TO_DO,
    'taxi_stand': ACTIVITY_TYPE_THINGS_TO_DO,
    'tourist_attraction': ACTIVITY_TYPE_THINGS_TO_DO,
    'train_station': ACTIVITY_TYPE_THINGS_TO_DO,
    'transit_station': ACTIVITY_TYPE_THINGS_TO_DO,
    'travel_agency': ACTIVITY_TYPE_THINGS_TO_DO,
    'university': ACTIVITY_TYPE_THINGS_TO_DO,
    'veterinary_care': ACTIVITY_TYPE_THINGS_TO_DO,
    'zoo': ACTIVITY_TYPE_THINGS_TO_DO,
};

export const guessPlaceType = (types) => {
    // see https://developers.google.com/places/supported_types
    console.log('guessPlaceType', types);
    var guessed = (types || [])
        .map(function (e) { return typeMap[e]; })
        .filter(function (e) { return typeof e !== void (0) && e !== null });
    // .sort(function(a, b) { return a - b });
    if (guessed.length >= 1 && guessed[0] !== void (0) && guessed[0] !== null) {
        console.log('guessPlaceType: guessed', guessed, ACTIVITY_TYPES, 'returning', guessed[0], ACTIVITY_TYPES[guessed[0]], '|', guessed[0] !== void (0));
        return +guessed[0];
    } else {
        return 1; // things to do in all unclear cases
    }
}


const paymentTypeMap = {
    'accounting': PAYMENT_TYPE_INCLUDED,
    'airport': PAYMENT_TYPE_INCLUDED,
    'amusement_park': PAYMENT_TYPE_PAY_AT_LOCATION,
    'aquarium': PAYMENT_TYPE_PAY_AT_LOCATION,
    'art_gallery': PAYMENT_TYPE_PAY_AT_LOCATION,
    'atm': PAYMENT_TYPE_PAY_AT_LOCATION,
    'bakery': PAYMENT_TYPE_PAY_AT_LOCATION,
    'bank': PAYMENT_TYPE_PAY_AT_LOCATION,
    'bar': PAYMENT_TYPE_PAY_AT_LOCATION,
    'beauty_salon': PAYMENT_TYPE_PAY_AT_LOCATION,
    'bicycle_store': PAYMENT_TYPE_PAY_AT_LOCATION,
    'book_store': PAYMENT_TYPE_PAY_AT_LOCATION,
    'bowling_alley': PAYMENT_TYPE_PAY_AT_LOCATION,
    'bus_station': PAYMENT_TYPE_PAY_AT_LOCATION,
    'cafe': PAYMENT_TYPE_PAY_AT_LOCATION,
    'campground': PAYMENT_TYPE_INCLUDED,
    'car_dealer': PAYMENT_TYPE_PAY_AT_LOCATION,
    'car_rental': PAYMENT_TYPE_PAY_AT_LOCATION,
    'car_repair': PAYMENT_TYPE_PAY_AT_LOCATION,
    'car_wash': PAYMENT_TYPE_PAY_AT_LOCATION,
    'casino': PAYMENT_TYPE_PAY_AT_LOCATION,
    'cemetery': PAYMENT_TYPE_INCLUDED,
    'church': PAYMENT_TYPE_INCLUDED,
    'city_hall': PAYMENT_TYPE_INCLUDED,
    'clothing_store': PAYMENT_TYPE_PAY_AT_LOCATION,
    'convenience_store': PAYMENT_TYPE_PAY_AT_LOCATION,
    'courthouse': PAYMENT_TYPE_INCLUDED,
    'dentist': PAYMENT_TYPE_PAY_AT_LOCATION,
    'department_store': PAYMENT_TYPE_PAY_AT_LOCATION,
    'doctor': PAYMENT_TYPE_PAY_AT_LOCATION,
    'drugstore': PAYMENT_TYPE_PAY_AT_LOCATION,
    'electrician': PAYMENT_TYPE_PAY_AT_LOCATION,
    'electronics_store': PAYMENT_TYPE_PAY_AT_LOCATION,
    'embassy': PAYMENT_TYPE_INCLUDED,
    'fire_station': PAYMENT_TYPE_INCLUDED,
    'florist': PAYMENT_TYPE_PAY_AT_LOCATION,
    'funeral_home': PAYMENT_TYPE_INCLUDED,
    'furniture_store': PAYMENT_TYPE_PAY_AT_LOCATION,
    'gas_station': PAYMENT_TYPE_PAY_AT_LOCATION,
    'grocery_or_supermarket': PAYMENT_TYPE_PAY_AT_LOCATION,
    'gym': PAYMENT_TYPE_PAY_AT_LOCATION,
    'hair_care': PAYMENT_TYPE_PAY_AT_LOCATION,
    'hardware_store': PAYMENT_TYPE_PAY_AT_LOCATION,
    'hindu_temple': PAYMENT_TYPE_INCLUDED,
    'home_goods_store': PAYMENT_TYPE_PAY_AT_LOCATION,
    'hospital': PAYMENT_TYPE_INCLUDED,
    'insurance_agency': PAYMENT_TYPE_PAY_AT_LOCATION,
    'jewelry_store': PAYMENT_TYPE_PAY_AT_LOCATION,
    'laundry': PAYMENT_TYPE_PAY_AT_LOCATION,
    'lawyer': PAYMENT_TYPE_PAY_AT_LOCATION,
    'library': PAYMENT_TYPE_INCLUDED,
    'light_rail_station': PAYMENT_TYPE_INCLUDED,
    'liquor_store': PAYMENT_TYPE_PAY_AT_LOCATION,
    'local_government_office': PAYMENT_TYPE_INCLUDED,
    'locksmith': PAYMENT_TYPE_PAY_AT_LOCATION,
    'lodging': PAYMENT_TYPE_INCLUDED,
    'meal_delivery': PAYMENT_TYPE_PAY_AT_LOCATION,
    'meal_takeaway': PAYMENT_TYPE_PAY_AT_LOCATION,
    'mosque': PAYMENT_TYPE_INCLUDED,
    'movie_rental': PAYMENT_TYPE_PAY_AT_LOCATION,
    'movie_theater': PAYMENT_TYPE_PAY_AT_LOCATION,
    'moving_company': PAYMENT_TYPE_PAY_AT_LOCATION,
    'museum': PAYMENT_TYPE_PAY_AT_LOCATION,
    'night_club': PAYMENT_TYPE_PAY_AT_LOCATION,
    'painter': PAYMENT_TYPE_PAY_AT_LOCATION,
    'park': PAYMENT_TYPE_INCLUDED,
    'parking': PAYMENT_TYPE_PAY_AT_LOCATION,
    'pet_store': PAYMENT_TYPE_PAY_AT_LOCATION,
    'pharmacy': PAYMENT_TYPE_PAY_AT_LOCATION,
    'physiotherapist': PAYMENT_TYPE_PAY_AT_LOCATION,
    'plumber': PAYMENT_TYPE_PAY_AT_LOCATION,
    'police': PAYMENT_TYPE_INCLUDED,
    'post_office': PAYMENT_TYPE_PAY_AT_LOCATION,
    'primary_school': PAYMENT_TYPE_INCLUDED,
    'real_estate_agency': PAYMENT_TYPE_PAY_AT_LOCATION,
    'restaurant': PAYMENT_TYPE_PAY_AT_LOCATION,
    'roofing_contractor': PAYMENT_TYPE_PAY_AT_LOCATION,
    'rv_park': PAYMENT_TYPE_PAY_AT_LOCATION,
    'school': PAYMENT_TYPE_INCLUDED,
    'secondary_school': PAYMENT_TYPE_INCLUDED,
    'shoe_store': PAYMENT_TYPE_PAY_AT_LOCATION,
    'shopping_mall': PAYMENT_TYPE_PAY_AT_LOCATION,
    'spa': PAYMENT_TYPE_PAY_AT_LOCATION,
    'stadium': PAYMENT_TYPE_PAY_AT_LOCATION,
    'storage': PAYMENT_TYPE_PAY_AT_LOCATION,
    'store': PAYMENT_TYPE_PAY_AT_LOCATION,
    'subway_station': PAYMENT_TYPE_PAY_AT_LOCATION,
    'supermarket': PAYMENT_TYPE_PAY_AT_LOCATION,
    'synagogue': PAYMENT_TYPE_INCLUDED,
    'taxi_stand': PAYMENT_TYPE_PAY_AT_LOCATION,
    'tourist_attraction': PAYMENT_TYPE_INCLUDED,
    'train_station': PAYMENT_TYPE_PAY_AT_LOCATION,
    'transit_station': PAYMENT_TYPE_PAY_AT_LOCATION,
    'travel_agency': PAYMENT_TYPE_PAY_AT_LOCATION,
    'university': PAYMENT_TYPE_INCLUDED,
    'veterinary_care': PAYMENT_TYPE_PAY_AT_LOCATION,
    'zoo': PAYMENT_TYPE_PAY_AT_LOCATION,
};

export const guessPlacePaymentType = (types) => {
    // see https://developers.google.com/places/supported_types
    console.log('guessPlacePaymentType', types);
    var guessed = (types || [])
        .map(function (e) { return paymentTypeMap[e]; })
        .filter(function (e) { return typeof e !== void (0) && e !== null });
    // .sort(function(a, b) { return a - b });
    if (guessed.length >= 1 && guessed[0] !== void (0) && guessed[0] !== null) {
        console.log('guessPlacePaymentType: guessed', guessed, ACTIVITY_TYPES, 'returning', guessed[0], ACTIVITY_TYPES[guessed[0]], '|', guessed[0] !== void (0));
        return +guessed[0];
    } else {
        return 1; // things to do in all unclear cases
    }
}


// export const activityTypeLabel = (id) => {
//     const label = ACTIVITY_TYPES[id];
//     if (!label) {
//         return ACTIVITY_TYPES[1];
//     }
//     return label;
// }

// export const activityTypeOptions = () => {
//     return Object.keys(ACTIVITY_TYPES).map((e) => ({
//         id: e,
//         name: ACTIVITY_TYPES[e],
//     }));
// }

// export const paymentTypeLabel = (id) => (PAYMENT_TYPES[id] ? PAYMENT_TYPES[id] : PAYMENT_TYPES[0]);

// export const paymentTypeOptions = () => (Object.keys(PAYMENT_TYPES).map( (e) => ({ id: e, name: PAYMENT_TYPES[e], }) ) );

// export const priceTypeOptions = () => (Object.keys(PRICE_TYPES).map( (e) => ({ id: e, name: PRICE_TYPES[e], }) ) );

export const getPriceString = (rec, currencyMap) => {
    const paymentType = +rec.payment_type;
    const priceType = +rec.price_type;
    const priceLevel = +rec.price_level;
    const costMin = rec.costMin;
    const costMax = rec.costMax;
    const cost = rec.cost || rec.costMin;
    // const prefix = rec.cost_prefix;
    // const unit = rec.cost_unit;
    const cur = rec.currency ? currencyMap[rec.currency] : currencyMap[1]; // assume 1 is USD
    const curSymbol = cur.symbol || '$';

    let value = null;
    switch (paymentType) {
        case PAYMENT_TYPE_PREPAID_ADDON:
        case PAYMENT_TYPE_PAY_AT_LOCATION:
            switch (priceType) {
                case PRICE_TYPE_PRICE_RANGE:
                    if (costMin && costMax) {
                        value = `${formatPrice(costMin, currencyMap)}-${formatPrice(costMax, currencyMap)}`;
                    } else if (costMin) {
                        value = `from ${formatPrice(costMin, currencyMap)}`;
                    } else if (costMax) {
                        value = `up to ${formatPrice(costMax, currencyMap)}`;
                    }
                    break;
                case PRICE_TYPE_EXACT_PRICE:
                    value = formatPrice(cost, cur);
                    break;
                case PRICE_TYPE_PRICE_LEVEL:
                    value = new Array(priceLevel + 1).join(curSymbol);
                    break;
                default:
                    break; // PRICE_TYPE_DONT_DISPLAY, value is null
            }
            break;
        default:
            break;
    }

    return value;
}

export const ConfirmationDialogText = {
    "save": { title: "Save changes before leaving?", body: "You have unsaved changes", okButtonText: "Save", cancelButtonText: "Cancel" },
    "delete": { title: "Please confirm", body: "Do you really want to delete this activity?", okButtonText: "Delete", cancelButtonText: "Cancel" },
    "delete_activity": { title: "Please confirm", body: "Do you really want to delete this activity?", okButtonText: "Delete", cancelButtonText: "Cancel" },
    "delete_activities": { title: "Please confirm", body: "Do you really want to delete these activities?", okButtonText: "Delete", cancelButtonText: "Cancel" },
}

export const getPriceDisplay = (rec) => {
    if (rec.payment_type === PAYMENT_TYPE_PREPAID_ADDON) {
        return {
            payment_type: PAYMENT_TYPE_PREPAID_ADDON,
            price_display: rec.price_type,
            disableIncluded: true,
            disableAddon: false,
            price_type_options: genHtmlOptions(PRICE_DISPLAY_PRICE_RANGE),
        };
    } else if (rec.payment_type === PAYMENT_TYPE_INCLUDED) {
        return {
            payment_type: PAYMENT_TYPE_INCLUDED,
            price_display: rec.price_type,
            disableIncluded: false,
            disableAddon: true,
            price_type_options: priceDisplayHtmlOptions,
        };
    } else {
        return {
            payment_type: PAYMENT_TYPE_PAY_AT_LOCATION,
            price_display: rec.price_type,
            disable_included: false,
            disable_addon: false,
            price_type_options: priceDisplayHtmlOptions,
        };
    }
}


export const setActivityInitialState = (activity_data) => {
    return {
        address: activity_data?.address || "",
        cost_max: ["number", "string"].indexOf(typeof activity_data?.cost_max) >= 0 ? +activity_data?.cost_max : 0,
        cost_min: ["number", "string"].indexOf(typeof activity_data?.cost_min) >= 0 ? +activity_data?.cost_min : 0,
        cost_prefix: activity_data?.cost_prefix || "",
        cost_unit: activity_data?.cost_unit || "",
        currency: activity_data?.currency || null,
        description: activity_data?.description || "",
        display_name: activity_data?.display_name || "",
        id: activity_data?.id || null,
        internal_notes: activity_data?.internal_notes || "",
        latitude: activity_data?.latitude || null,
        longitude: activity_data?.longitude || null,
        max_duration: activity_data?.max_duration || 0,
        min_duration: activity_data?.min_duration || 0,
        name: activity_data?.name || "",
        price_display: activity_data?.version === 0 ? PRICE_DISPLAY_NO_PRICE : activity_data?.price_display,
        payment_type: activity_data?.version === 0 ? PAYMENT_TYPE_PAY_AT_LOCATION : activity_data?.payment_type || 0,
        phone: activity_data?.phone || "",
        place_data: activity_data.place_data,
        place_id: activity_data?.place_id,
        preview_text: activity_data?.preview_text || "",
        price_level: activity_data?.price_level || 1,
        price_type: activity_data?.version === 0 ? PRICE_TYPE_DONT_DISPLAY : activity_data?.price_type || 0,
        opening_hours: activity_data?.opening_hours || [],
        type: activity_data?.type || 1,
        website: activity_data?.website || "",
        custom_id: activity_data?.custom_id,
        created_ts: activity_data?.created_ts,
        updated_ts: activity_data?.updated_ts,

        children: activity_data?.children || [],
        images: activity_data?.images || [],
        place_photos: activity_data?.place_photos,
        documents: activity_data?.documents || [],
        ratings: activity_data?.ratings || [],
        atag: activity_data?.atag || [],
        category: activity_data?.category || null,
        tour_operator: activity_data?.tour_operator || null,
    }

}

export const populateFromPlace = (place, activity) => {
    const pw = new PlaceWrapper(place);
    let a = activity;
    a.name = pw.name();
    a.display_name = pw.name().toString().substr(0, 256);
    a.type = pw.type();
    a.latitude = pw.latitude();
    a.longitude = pw.longitude();
    a.price_level = pw.price_level();
    a.address = pw.address();
    a.website = pw.website();
    a.phone = pw.phone();
    a.opening_hours = pw.schedule();
    a.place_photos = pw.photos(/* selectAll = */ true);

    a.price_type = +pw.price_type();
    a.payment_type = +pw.payment_type();
    a.ratings = pw.ratings();

    return a;

}
